var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('b-table',{attrs:{"striped":"","items":_vm.items}}),_vm._v(" Interno: "+_vm._s(_vm.botao.src)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }